import axios from "axios";

export const support = payload => {
    return axios.post('support', payload)
}